<template>
  <div class="form_index">
    <el-dialog
      class="form_dialog self_dialog"
      :title="$store.state.add_form.form_type == 'add' ? $t('view_form_dialog_add_form_207') : $t('view_form_dialog_add_form_208')"
      :visible.sync="dialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
       width="750px"
      @close="closeModule"
      :append-to-body="true">
      <div class="form_body" v-loading="formLoading">
        <div class="form_header">
          <my_input :title="$t('view_form_dialog_add_form_209')" :maxlength="100" type="one_level" titleWidth="84" width="350" :value.sync="form.title"></my_input>
          <p>
            <span class="title">{{$t('view_form_dialog_add_form_210')}}</span>
            <el-button size="small" @click="addFormItem" style="font-size: 13px">{{$t('view_form_dialog_add_form_item_184')}}</el-button>
          </p>
        </div>
        <table
          class="form_table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th style="width: 115px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_211')}}</div>
              </th>
              <th style="width: 236px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_212')}}</div>
              </th>
              <th style="width: 64px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_213')}}</div>
              </th>
              <th style="width: 64px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_214')}}</div>
              </th>
              <th style="width: 64px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_215')}}</div>
              </th>
              <th style="width: 90px;">
                <div class="table_cell">{{$t('view_form_dialog_add_form_216')}}</div>
              </th>
            </tr>
          </thead>
          <tbody class="form_table_body">
            <tr
              v-if="form.fields.contentList.length <= 0"
              class="empty"
            >
              <td style="width: 630px;">{{$t('view_form_dialog_add_form_217')}}</td>
            </tr>
            <tr
              class="form_item"
              v-for="(item, index) in form.fields.contentList"
              :key="index"
            >
              <td style="width: 115px;">
                <span style="width: 91px;display:inline-block;" v-text="item.title" :title="item.title"></span>
              </td>
              <td style="width: 236px;">
                  <input type="hidden" class="item-id" v-model="item.id"/>
                  <!--input-->
                  <el-input size="small" v-if="item.type == 'input' && item.moduleName !== 'phone'" v-model="item.value" :placeholder="item.placeholder" :disabled="true"></el-input>
                  <!--textarea -->
                  <el-input resize="none" type="textarea" rows="4" v-model="item.value" v-if="item.type == 'textarea'" :placeholder="item.placeholder" :disabled="true"></el-input>
                  <!--radio-->
                  <el-radio-group :placeholder="item.placeholder" v-model="item.value" v-if="item.type == 'radio'" class="vertical">
                    <el-radio v-for="(obj,index) in item.options" :key="index" :label="obj.value">{{obj.label}}</el-radio>
                  </el-radio-group>
                  <!--checkbox-->
                  <el-checkbox-group v-model="item.value" :placeholder="item.placeholder" v-if="item.type == 'checkbox'"  class="vertical">
                    <el-checkbox v-for="(obj,index) in item.options" :key="index" :label="obj.value">{{obj.label}}</el-checkbox>
                  </el-checkbox-group>
                  <!--select-->
                  <el-select size="small" style="width:220px" v-model="item.value" :disabled="true" :placeholder="item.placeholder" v-if="item.type == 'select'">
                    <el-option
                      v-for="obj in item.options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value">
                    </el-option>
                  </el-select>
                  <!--provinces-->
                  <span v-if="item.type == 'provinces'" class="horizontal">
                  <el-select size="small" :disabled="true" v-model="item.value" :placeholder="$t('view_dialog_index_116')">
                    <el-option
                      v-for="obj in item.options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value">
                    </el-option>
                  </el-select>
                  <el-select size="small" :disabled="true" v-model="item.value" :placeholder="$t('view_dialog_index_116')">
                    <el-option
                      v-for="obj in item.options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value">
                    </el-option>
                  </el-select>
                  <el-select v-if="item.countySelect == 'true'" size="small" :disabled="true" v-model="item.value" :placeholder="$t('view_dialog_index_116')">
                    <el-option
                      v-for="obj in item.options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value">
                    </el-option>
                  </el-select>
                </span>
                 <!--telephone-->
                <span v-if="item.moduleName === 'phone'" class="horizontal">
                  <el-select
                    v-if="item.areaSelect === 'true'"
                    size="small"
                    class="my_telephone_select"
                    :disabled="true"
                    v-model="item.value"
                    placeholder="+1"
                  >
                    <el-option
                      v-for="obj in item.options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value"
                    ></el-option>
                  </el-select>
                  <el-input size="small" :placeholder="item.placeholder" :disabled="true" v-model="item.value"></el-input>
                </span>
              </td>
              <td style="width: 64px;">
                <i class="icon_enabled" v-if="item.show" @click="updateDisplayStatus(item)"></i>
                <i class="icon_disabled" v-else @click="updateDisplayStatus(item)"></i>
              </td>
              <td style="width: 64px;">
                <i
                  class="icon_enabled"
                  v-if="item.require"
                  @click="updateMustStatus(item)"
                ></i>
                <i
                  class="icon_disabled"
                  v-else
                  @click="updateMustStatus(item)"
                ></i>
              </td>
              <td style="width: 64px;">
                <i
                  class="icon_arrow_up"
                  v-if="index !== 0"
                  @click="form_up(index)"
                ></i>
                <i
                  class="icon_arrow_down"
                  v-if="index !== form.fields.contentList.length - 1"
                  @click="form_down(index)"
                ></i>
              </td>
              <td style="width: 90px;">
                <i class="icon_edit" v-if="!item.isSystem" :title="$t('view_form_dialog_add_form_218')" @click="editFormItem(item,index)"></i>
                <i class="icon_edit icon_disabled" v-else :title="$t('view_form_dialog_add_form_219')"></i>
                <i
                  class="icon_delete"
                  @click="form_delete(index)"
                  v-if="!item.isSystem"
                ></i>
                <i
                  class="icon_delete icon_disabled"
                  :title="$t('view_form_dialog_add_form_220')"
                  v-else
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible = false">{{$t('view_public_topbar_14')}}</el-button>
        <el-button type="primary" @click="saveFormData">{{$t('view_public_topbar_15')}}</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import i18n from '../../language/index'

  import { saveForm } from '@/api/app';
  import Cookies from 'js-cookie'
  export default {
    name: 'form_index',
    data() {
      return {
        dialogVisible: true,
        formLoading: false,
        isShow: true,
        id: 1
      }
    },
    computed: {
      form() {
        let form = this.$store.state.add_form.edit_form
        if(this.$store.state.add_form.form_type === 'add') {
          form.title = ''
        }
        console.log(123,form)
        if(typeof form.fields == "string") {
          form.fields = JSON.parse(form.fields)
        }
        return form
      }
    },
    watch: {
      "form": {
        handler(val) {
          this.$nextTick(() => {
            this.dragDom()
          })
        },
        deep: true
      }
    },
    methods: {
      closeModule() {
        this.dialogVisible = false
        // 关闭表单项弹框
        this.$store.commit('add_form/set_add_form_show', false)
      },
      // 修改表单项是否显示的状态
      updateDisplayStatus(item) {
        item.show = !item.show
      },
      // 修改表单项是否必填的状态
      updateMustStatus(item) {
        item.require = !item.require
      },
      // 编辑表单项
      editFormItem(item, index) {
        // 修改表单项的操作类型 add 新增 edit 编辑
        this.$store.commit('add_form_item/set_form_item_type', 'edit')
        // 编辑的表单项的名称
        Cookies.set('cur_item_name_wm', item.moduleName)
        // 编辑的表单项的索引
        Cookies.set('cur_item_index_wm', index)
        // 打开表单项弹框
        this.$store.commit('add_form_item/set_add_form_item_show', true)
        // 编辑的表单项的对象
        this.$store.commit('add_form_item/set_cur_form_item', item)
        // 当前选择的表单项的名称
        this.$store.commit('add_form_item/set_select_name', item.moduleName)
      },
      // 删除表单项
      delFormItem(item, index) {
        this.$confirm(i18n.t('view_form_dialog_add_form_221'), '', {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: 'del_dialog'
        }).then(() => {
          this.form.fields.contentList.splice(index, 1)
        }).catch(() => {
        })
      },
      // 新增表单项
      addFormItem() {
        // 打开表单项弹框
        this.$store.commit('add_form_item/set_add_form_item_show', true)
        // 修改表单项的操作类型 add 新增 edit 编辑
        this.$store.commit('add_form_item/set_form_item_type', 'add')
        // 当前选择的表单项的名称
        this.$store.commit('add_form_item/set_select_name', 'input')
      },
      // 保存表单
      async saveFormData() {
        const title = this.form.title.replace(/(^\s*)|(\s*$)/g, '')
        if (title === '') {
          this.$message.warning(i18n.t('view_form_dialog_add_form_222'))
          return false
        }
        if (this.form.fields.contentList.length === 0) {
          this.$message.warning(i18n.t('view_form_dialog_add_form_223'))
          return false
        }
        let data = await this.templet.addForm(this.form);
        if(data == 'true') {
          this.templet.getFormList()
        }
        this.dialogVisible = false
      },
      // 拖拽
      dragDom() { // 初始化drap事件
        const that = this
        $('.form_table_body').sortable({
          placeholder: 'form_placeholder',
          cursor: 'move',
          axis: 'y',
          containment: 'parent',
          stop: function(event, ui) {
            let len = $(this).children('.form_item').length
            let list = []
            for (let i = 0; i < len; i++) {
              const id = $(this).children('.form_item').eq(i).find('.item-id').val();
              for (let j = 0; j < that.form.fields.contentList.length; j++) {
                if (id !== undefined && id == that.form.fields.contentList[j].id) {
                  list.push(that.form.fields.contentList[j]);
                }
              }
            }
            that.form.fields.contentList = [];
            that.$nextTick(() => {
              that.form.fields.contentList = list;
            })
          }
        })
      },
      form_up (index) {
        this.form.fields.contentList.splice(index - 1, 0, this.form.fields.contentList.splice(index, 1)[0])
      },
      form_down (index) {
        this.form.fields.contentList.splice(index + 1, 0, this.form.fields.contentList.splice(index, 1)[0])
      },
      form_delete (index) {
        this.form.fields.contentList.splice(index, 1)
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.dragDom()
      })
    }
  }
</script>

<style scoped lang="scss">
  .my_telephone_select {
    width: 195px;
    /deep/ .el-input__inner {
      padding-left: 5px;
      padding-right: 10px;
    }
  }
  .form_table {
    overflow: hidden;
    margin-bottom: 13px;
    max-width: 100%;
    border: 1px solid #e3e2e8;
    box-sizing: border-box;
    color: #333;
    thead {
      display: inline-block;
      width: 100%;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      background-color: #f8f9fb;
      .table_cell {
        font-weight: 500;
        border-right: 1px solid #e3e2e8;
      }
      & tr th:last-child .table_cell {
        border: none;
      }
      tr {
        width: 100%;
        th {
          height: 50px;
          &:first-child {
            padding-left: 24px;
            text-align: left;
          }
        }
      }
    }
    tbody {
      display: inline-block;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: 217px;
      width: 100%;
      tr {
        width: 100%;
        height: 50px;
        cursor: move;
        &.empty {
          cursor: default;
        }
        &.empty :hover {
          background-color: #fff;
        }
        &:nth-child(even) {
          background: rgb(248, 249, 251);
        }
        &:hover {
          background: #eef2fc;
        }
        &:active {
          background: #fff;
        }
        td {
          text-align: center;
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: 50px;
          }
          &:nth-of-type(1) {
            text-align: left;
            padding-left: 24px;
          }
          &:nth-of-type(3) {
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(~@/assets/image/cssSprite.png) no-repeat;
              cursor: pointer;
              &.icon_enabled {
                background-position: -382px -72px;
              }
              &.icon_disabled {
                background-position: -467px -72px;
              }
            }
          }
          &:nth-of-type(4) {
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(~@/assets/image/cssSprite.png) no-repeat;
              cursor: pointer;
              &.icon_enabled {
                background-position: -382px -72px;
              }
              &.icon_disabled {
                background-position: -467px -72px;
              }
            }
          }
          &:nth-of-type(5) {
            i {
              display: inline-block;
              width: 17px;
              height: 17px;
              background: url(~@/assets/image/cssSprite.png) no-repeat;
              cursor: pointer;
              &.icon_arrow_up {
                background-position: -1029px -118px;
              }
              &.icon_arrow_down {
                background-position: -989px -118px;
              }
              &:hover {
                background-position-y: -72px;
              }
            }
          }
          &:nth-of-type(6) {
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(~@/assets/image/mbg01.png) no-repeat;
              cursor: pointer;
              &.icon_disabled {
                cursor: not-allowed;
              }
              &.icon_delete {
                background-position: -891px -75px;
              }
              &.icon_edit {
                background-position: -820px -75px;
                margin-right: 20px;
              }
              &:hover {
                background-position-y: -109px;
              }
            }
          }
        }
      }
    }
  }
  .form_body {
    margin: 0 10px;
  }
  .form_header p{
    display: flex;
    justify-content: space-between;
    height: 32px;
    margin-bottom: 10px;
    line-height: 32px;
  }
  .form_header p .title{
    width: 95px;
    text-align: right;
    display: inline-block;
    font-size: 13px;
  }
  .vertical{
    display: flex;
    flex-direction: column;
  }
  .horizontal{
    display: flex;
    justify-content: start;
  }
  .cus_fileUpload{
    height: 40px;
  }
  .cus_fileUpload i {
    color: #999;
    font-size: 12px;
    margin-left: 14px;
    text-align: left;
  }
  .module {
    pointer-events: none !important;
    cursor: move !important;
  }




</style>



// WEBPACK FOOTER //
// src/view/form_dialog/add_form.vue